<template>
  <v-dialog v-model="active" scrollable persistent>
    <v-card>
      <v-card-title class="px-4">
        {{ dialog.description }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5 px-4">
        <div style="overflow: hidden; padding-top: 10px">
          <v-textarea
            v-model="observation"
            :disabled="!dialog.editable"
            outlined
            label="Observações"
            height="150px"
            hide-details
            style="width: calc(100% - 35px); float: left"
          ></v-textarea>
          <button
            v-if="!loading || dialog.editable"
            @click="recognitionVoice"
            :class="{ 'voice-recognition': true, recording: speechToText.isRecognizing }"
            style="
              cursor: pointer;
              width: 30px;
              height: 150px;
              margin-left: 5px;
              text-align: center;
              border: 1px dashed rgba(0, 0, 0, 0.4);
              border-radius: 6px;
            "
          >
            <div :key="speechToText.isRecognizing">
              <div v-if="speechToText.isRecognizing">
                <v-icon size="28" color="#fff">mdi-microphone</v-icon>
              </div>
              <div v-else>
                <v-icon size="28">mdi-microphone</v-icon>
              </div>
            </div>
          </button>
        </div>

        <div v-if="dialog.editable && !loading" class="box mt-4">
          <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
            <div @click="openAlternativeTakePhoto({ order: nextOrder, position: 'first' })" class="add">
              <v-icon size="35">mdi-camera</v-icon>
            </div>
          </div>

          <div v-else>
            <input
              @change="onFileChange($event, { order: nextOrder, position: 'first' })"
              name="new-order-first"
              accept="image/*,video/mp4,.mp4,.mov"
              type="file"
              class="input-upload"
              multiple
            />
            <div class="add">
              <v-icon size="35">mdi-camera</v-icon>
            </div>
          </div>
        </div>

        <Viewer :options="viewer_options" :images="images">
          <div class="mt-4 media-grid">
            <div v-for="item in groupMedias" :key="item.order" class="mt-3 media-section-items" :class="{ 'single-column': item.isFromItemTable }">
              <div
                class="media-item"
                :class="{
                  'has-image': !!item.first
                }"
              >
                <template v-if="item.first">
                  <v-progress-linear
                    v-if="groupMediaOrdersLoading.includes(item.order)"
                    indeterminate
                    color="primary"
                    size="20"
                    width="3"
                  ></v-progress-linear>
                  <template v-if="item.first.media_type?.includes('video/')">
                    <div class="video-thumbnail-container" @click.stop="openModalVideoPlayer(item.first)" :data-video-src="getMediaUrl(item.first)">
                      <video class="media-thumb media-thumb--video" muted playsinline preload="metadata">
                        <source :src="getMediaUrl(item.first)" type="video/mp4" />
                      </video>
                      <div class="video-play-icon">
                        <v-icon size="48" color="white">mdi-play-circle</v-icon>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="media-thumb">
                      <v-img :src="getMediaUrl(item.first)" alt="Foto" height="214px" @click="show" />
                    </div>
                  </template>
                  <div class="media-date">{{ formatDateTime(item.first.created_at) }}</div>
                  <div class="media-actions">
                    <v-btn
                      v-if="item.first.id || item.isFromItemTable"
                      size="small"
                      variant="flat"
                      @click.stop="openModalDeleteMedia(item.first, item.order, false, item.isFromItemTable)"
                      style="padding: 0px; min-width: 35px; width: 35px"
                    >
                      <v-icon color="#F56565">mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-else>
                  <div class="capture-box capture-box--inner">
                    <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'" class="capture-box__content">
                      <div @click="openAlternativeTakePhoto({ order: item.order, position: 'first' })" class="add">
                        <v-icon size="35">mdi-camera</v-icon>
                      </div>
                    </div>
                    <label v-else :for="`order-${item.order}-first`">
                      <div class="capture-box__content">
                        <input
                          style="display: none"
                          accept="image/*,video/mp4,.mp4,.heic,.heif"
                          :name="`order-${item.order}-first`"
                          type="file"
                          class="input-upload"
                          :id="`order-${item.order}-first`"
                          @change="onFileChange($event, { order: item.order, position: 'first' })"
                        />
                        <v-icon size="40" color="#777">mdi-camera</v-icon>
                      </div>
                    </label>
                  </div>
                </template>
              </div>

              <div
                v-if="!item.isFromItemTable"
                class="media-item"
                :class="{
                  'has-image': !!item.second
                }"
              >
                <template v-if="item.second">
                  <v-progress-linear
                    v-if="groupMediaOrdersLoading.includes(item.order)"
                    indeterminate
                    color="primary"
                    size="20"
                    width="3"
                  ></v-progress-linear>
                  <template v-if="item.second.media_type?.includes('video/')">
                    <div class="video-thumbnail-container" @click.stop="openModalVideoPlayer(item.second)" :data-video-src="getMediaUrl(item.second)">
                      <video class="media-thumb media-thumb--video" muted playsinline preload="metadata">
                        <source :src="getMediaUrl(item.second)" type="video/mp4" />
                      </video>
                      <div class="video-play-icon">
                        <v-icon size="48" color="white">mdi-play-circle</v-icon>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="media-thumb">
                      <v-img :src="getMediaUrl(item.second)" alt="Foto" height="214px" @click="show" />
                    </div>
                  </template>
                  <div class="media-date">{{ formatDateTime(item.second.created_at) }}</div>
                  <div class="media-actions">
                    <v-btn
                      v-if="item.second.id"
                      size="small"
                      variant="flat"
                      @click.stop="openModalDeleteMedia(item.second, item.order, true)"
                      style="padding: 0px; min-width: 35px; width: 35px"
                    >
                      <v-icon color="#F56565">mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-else>
                  <div class="capture-box capture-box--inner">
                    <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'" class="capture-box__content">
                      <div @click="openAlternativeTakePhoto({ order: item.order, position: 'second' })" class="add">
                        <v-icon size="35">mdi-camera</v-icon>
                      </div>
                    </div>
                    <label v-else :for="`order-${item.order}-second`">
                      <div class="capture-box__content">
                        <input
                          style="display: none"
                          :name="`order-${item.order}-second`"
                          accept="image/*,video/mp4,.mp4,.heic,.heif"
                          type="file"
                          class="input-upload"
                          :id="`order-${item.order}-second`"
                          @change="onFileChange($event, { order: item.order, position: 'second' })"
                        />
                        <v-icon size="40" color="#777">mdi-camera</v-icon>
                      </div>
                    </label>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </Viewer>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn @click="closeDialog()" :loading="!!groupMediaOrdersLoading.length" text> Cancelar </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="saveItemObs()" :disabled="!dialog.editable" :loading="!!groupMediaOrdersLoading.length" color="primary" depressed>
          Salvar Observação
        </v-btn>
      </v-card-actions>
    </v-card>

    <RecognitionVoiceService v-if="speechToText.isRecognizing" @recognized-voice="handleSpeechRecognitionResult" @cancel="cancelRecognizeVoice" />

    <TakePhotoDialog
      v-if="TakePhotoDialog.modal"
      :component="TakePhotoDialog.component"
      @media-captured="mediaCapturedAlternative"
      @close="closeAlternativeTakePhoto"
    />

    <ModalDeleteMedia
      :is-active="modalDeleteMedia.isOpen"
      :loading="modalDeleteMedia.loading"
      @close="closeModalDeleteMedia"
      @save="saveModalDeleteMedia"
    />

    <ModalVideoPlayer :is-active="modalVideoPlayer.isOpen" :video-url="modalVideoPlayer.videoUrl" @close="closeModalVideoPlayer" />
  </v-dialog>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import heic2any from 'heic2any';
import { component as Viewer } from 'v-viewer';
import RecognitionVoiceService from '@/components/Common/RecognitionVoiceService';
import TakePhotoDialog from './TakePhotoDialog';
import ModalDeleteMedia from './ChecklistDialogItemObs/ModalDeleteMedia';
import ModalVideoPlayer from '../../Common/ModalVideoPlayer';

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    dialog: Object,
    groupMediaOrdersLoading: Array
  },
  components: {
    RecognitionVoiceService,
    TakePhotoDialog,
    ModalDeleteMedia,
    ModalVideoPlayer,
    Viewer
  },
  data: () => ({
    active: false,
    loading: false,
    observation: '',
    viewer_options: {
      button: true,
      navbar: true,
      title: false,
      toolbar: false,
      tooltip: true,
      movable: true,
      zoomable: true,
      rotatable: true,
      scalable: true,
      transition: true,
      fullscreen: true,
      keyboard: true
    },
    speechToText: {
      target: null,
      recognition: null,
      isRecognizing: false
    },
    TakePhotoDialog: {
      modal: false,
      component: null,
      index: null,
      positionInfo: null
    },
    groupMedias: [],
    modalDeleteMedia: {
      isOpen: false,
      media: null,
      order: null,
      isSecond: false,
      isFromItemTable: false,
      loading: false
    },
    modalVideoPlayer: {
      isOpen: false,
      videoUrl: null
    }
  }),
  watch: {
    isActive() {
      this.active = this.isActive;

      if (this.isActive) {
        if (this.dialog.item) {
          this.observation = this.dialog.value.observation || '';
        }

        this.organizeMedias();
      }
    },
    active() {
      if (!this.active) {
        this.loading = false;
        this.$emit('close');
      }
    },
    'dialog.value.media_url': function handler() {
      this.organizeMedias();
      this.loading = false;
    },
    'dialog.value.service_order_checklist_item_medias': function handler() {
      this.organizeMedias();
      this.loading = false;
    }
  },
  computed: {
    parameterMediaCameraType() {
      return this.$store.getters['Auth/parameters']?.find((parameter) => parameter.name === 'media_camera_type')?.value;
    },
    nextOrder() {
      if (this.groupMedias.length === 0) return 1;

      const newSystemItems = this.groupMedias.filter((item) => !item.isFromItemTable);

      if (newSystemItems.length === 0) return 1;

      const maxOrder = Math.max(...newSystemItems.map((item) => item.order));
      return maxOrder + 1;
    },
    images() {
      const imagesArray = [];
      this.groupMedias.forEach((item) => {
        const mediaUrlFirst = item.first?.media_url;
        const isFirstVideoFile =
          mediaUrlFirst &&
          (mediaUrlFirst?.includes('.mp4') || mediaUrlFirst?.includes('.mov') || mediaUrlFirst?.includes('.avi') || mediaUrlFirst?.includes('.webm'));

        if (item.first && !isFirstVideoFile) {
          imagesArray.push(item.first.media_url);
        }

        const mediaUrlSecond = item.second?.media_url;
        const isSecondVideoFile =
          mediaUrlSecond &&
          (mediaUrlSecond?.includes('.mp4') ||
            mediaUrlSecond?.includes('.mov') ||
            mediaUrlSecond?.includes('.avi') ||
            mediaUrlSecond?.includes('.webm'));

        if (item.second && !isSecondVideoFile) {
          imagesArray.push(item.second.media_url);
        }
      });
      return imagesArray;
    }
  },
  methods: {
    show() {
      this.$viewerApi({
        images: this.images,
        options: this.viewer_options
      });
    },
    cancelRecognizeVoice() {
      this.speechToText = {
        target: null,
        recognition: null,
        isRecognizing: false
      };
    },
    recognitionVoice(target) {
      this.speechToText.target = target;
      this.speechToText.isRecognizing = true;
    },
    handleSpeechRecognitionResult(result) {
      if (!result || typeof result !== 'string') {
        console.warn('Resultado de reconhecimento de voz inválido:', result);
        this.speechToText.isRecognizing = false;
        return;
      }

      if (this.observation === null || this.observation === undefined) {
        this.observation = '';
      } else if (this.observation.length > 0) {
        this.observation += '\n';
      }
      this.observation += result;
      this.speechToText.isRecognizing = false;
    },
    saveItemObs() {
      const self = this;
      self.loading = true;
      self.$http
        .patch(`/service_order/${self.dialog.service_order_id}/checklist/${self.dialog.value.service_order_checklist_id}/upsert`, {
          observation: self.observation,
          item_id: self.dialog.item.id
        })
        .then((response) => {
          self.closeDialog(response.data.service_order_checklist_item);
        })
        .finally(() => {
          self.loading = false;
        });
    },
    async onFileChange(event, positionInfo) {
      if (this.loading) return;

      const newInfos = JSON.parse(JSON.stringify(this.dialog));

      if (event.target.files.length) {
        const promises = Array.from(event.target.files).map(async (file, index) => {
          const actualOrder = Number(positionInfo.order) + index;

          this.$emit('order-loading', actualOrder);

          if (file.type === 'image/heic') {
            const url = URL.createObjectURL(file);
            const res = await fetch(url);
            const blob = await res.blob();
            const convertedBlob = await heic2any({ blob, quality: 0.5, toType: 'image/jpeg' });
            file = new File([convertedBlob], `${Date.now()}_converted.jpg`, { type: 'image/jpeg' });
          }

          const formData = new FormData();
          formData.append('file', file);
          this.loading = true;
          this.$emit('add-file', newInfos, formData, file, { ...positionInfo, order: actualOrder });
        });

        await Promise.all(promises);
      }
    },
    deleteMedia() {
      const self = this;
      self.loading = true;
      this.modalDeleteMedia.loading = true;
      self.$http
        .post(
          `/service_order/${self.dialog.service_order_id}/checklist/${self.dialog.value.service_order_checklist_id}/item/${self.dialog.value.id}/media/delete`
        )
        .then(() => {
          this.dialog.value.media_url = null;

          const groupMediaIndex = this.groupMedias.findIndex((g) => g.isFromItemTable);

          if (groupMediaIndex !== -1) {
            const groupMedia = this.groupMedias[groupMediaIndex];

            if (!groupMedia?.first && !groupMedia?.second) {
              this.groupMedias.splice(groupMediaIndex, 1);
            }
          }

          this.$emit('remove-file', this.dialog.value.id, this.modalDeleteMedia.media.id, true);
        })
        .finally(() => {
          this.closeModalDeleteMedia();
          self.loading = false;
          this.modalDeleteMedia.loading = false;
        });
    },
    closeDialog(updatedItemValue) {
      this.$emit('close', updatedItemValue);
    },
    updateItem(updatedItemValue) {
      this.$emit('update', updatedItemValue);
    },
    downloadMedia(mediaUrl) {
      window.open(`savethisimage://?url=${mediaUrl}`);
    },
    openAlternativeTakePhoto(positionInfo) {
      this.TakePhotoDialog = {
        modal: true,
        component: 'checklist',
        index: false,
        positionInfo
      };
    },
    closeAlternativeTakePhoto() {
      this.TakePhotoDialog = {
        modal: false,
        component: null,
        index: null,
        positionInfo: null
      };
    },
    mediaCapturedAlternative(payload) {
      const file = new File([payload.blob], `${Date.now()}.${payload.type === 'photo' ? 'jpg' : 'mp4'}`, { type: payload.blob.type });

      const { positionInfo } = this.TakePhotoDialog;

      this.$emit('order-loading', positionInfo.order);

      const newInfos = JSON.parse(JSON.stringify(this.dialog));

      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        this.loading = true;
        this.$emit('add-file', newInfos, formData, file, { ...positionInfo });
      }

      this.TakePhotoDialog = {
        modal: false,
        component: null,
        index: null,
        positionInfo: null
      };
    },
    getMediaUrl(media) {
      return media.media_url;
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.toLocaleDateString()} às ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    },
    openModalDeleteMedia(media, order, isSecond, isFromItemTable = false) {
      this.modalDeleteMedia = {
        isOpen: true,
        order,
        media,
        isSecond,
        isFromItemTable
      };
    },
    closeModalDeleteMedia() {
      this.modalDeleteMedia = {
        isOpen: false,
        media: null,
        order: null,
        isSecond: false,
        isFromItemTable: false
      };
    },
    saveModalDeleteMedia() {
      if (this.modalDeleteMedia.isFromItemTable) {
        this.deleteMedia();
        return;
      }

      const self = this;
      self.loading = true;
      this.modalDeleteMedia.loading = true;
      self.$http
        .delete(
          `/service_order/${self.dialog.service_order_id}/checklist/${self.dialog.value.service_order_checklist_id}/item/${self.dialog.value.id}/media/${this.modalDeleteMedia.media.id}/table/delete`
        )
        .then(() => {
          const groupMediaIndex = this.groupMedias.findIndex((g) => g.order === this.modalDeleteMedia.order);

          if (groupMediaIndex === -1) return;

          const groupMedia = this.groupMedias[groupMediaIndex];

          groupMedia[this.modalDeleteMedia.isSecond ? 'second' : 'first'] = null;

          const mediaIndex = this.dialog.value.service_order_checklist_item_medias.findIndex(({ id }) => id === this.modalDeleteMedia.media.id);
          if (mediaIndex !== -1) {
            this.dialog.value.service_order_checklist_item_medias.splice(mediaIndex, 1);
          }

          if (!groupMedia?.first && !groupMedia?.second) {
            this.groupMedias.splice(groupMediaIndex, 1);
          }

          this.$emit('remove-file', this.dialog.value.id, this.modalDeleteMedia.media.id);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.closeModalDeleteMedia();
          self.loading = false;
          this.modalDeleteMedia.loading = false;
        });
    },
    organizeMedias() {
      this.groupMedias = [];

      const hasNewSystemMedias = this.dialog.value?.service_order_checklist_item_medias?.length > 0;
      const mediaUrl = this.dialog.value?.media_url?.toLowerCase();

      const isVideoFile =
        mediaUrl && (mediaUrl.includes('.mp4') || mediaUrl.includes('.mov') || mediaUrl.includes('.avi') || mediaUrl.includes('.webm'));

      if (mediaUrl && isVideoFile && !hasNewSystemMedias) {
        const videoMediaObj = {
          id: this.dialog.value.id,
          service_order_checklist_item_id: this.dialog.value.id,
          tag: `checklist_${this.dialog.value.service_order_checklist_id}_item_${this.dialog.value.id}_1`,
          media_url: mediaUrl,
          media_type: isVideoFile ? 'video/mp4' : 'image/jpeg',
          created_at: this.dialog.value.updated_at || this.dialog.value.created_at || new Date().toISOString(),
          active: 1
        };

        this.groupMedias.push({
          order: 1,
          isFromItemTable: true,
          first: videoMediaObj,
          second: null
        });
      } else if (mediaUrl) {
        this.groupMedias.push({
          order: 0,
          isFromItemTable: true,
          first: {
            media_type: isVideoFile ? 'video/mp4' : 'image/jpeg',
            media_url: this.dialog.value.media_url,
            created_at: this.dialog.value.updated_at || this.dialog.value.created_at
          },
          second: null
        });
      }

      const itemMedias = this.dialog?.value?.service_order_checklist_item_medias;

      if (!itemMedias?.length) return;

      itemMedias.forEach((media) => {
        if (!media.tag) {
          return;
        }

        const tagSplitted = media.tag.split('_');
        const order = Number(tagSplitted[4]);

        const mediaItemIndex = this.groupMedias.findIndex((m) => m.order === order);

        const mediaUrl = media.media_url.toLowerCase();

        const isVideoFile =
          mediaUrl && (mediaUrl.includes('.mp4') || mediaUrl.includes('.mov') || mediaUrl.includes('.avi') || mediaUrl.includes('.webm'));

        const mediaData = {
          ...media,
          ...(!media.media_type ? { media_type: isVideoFile ? 'video/mp4' : 'image/jpeg' } : {})
        };

        if (mediaItemIndex !== -1) {
          this.groupMedias[mediaItemIndex][tagSplitted[5] ? 'second' : 'first'] = mediaData;
        } else {
          this.groupMedias.push({
            order,
            isFromItemTable: false,
            [tagSplitted[5] ? 'second' : 'first']: mediaData,
            [tagSplitted[5] ? 'first' : 'second']: null
          });
        }
      });

      this.groupMedias.sort((a, b) => {
        if (a.isFromItemTable && !b.isFromItemTable) return -1;
        if (!a.isFromItemTable && b.isFromItemTable) return 1;
        return b.order - a.order;
      });
    },
    openModalVideoPlayer(media) {
      this.modalVideoPlayer.isOpen = true;
      this.modalVideoPlayer.videoUrl = this.getMediaUrl(media);
    },
    closeModalVideoPlayer() {
      this.modalVideoPlayer.isOpen = false;
      this.modalVideoPlayer.videoUrl = null;
    }
  }
};
</script>

<style lang="scss">
.box {
  position: relative;

  .input-upload {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 98;
  }

  .remove-image {
    background-color: #fff;
    border-radius: 50%;
    position: absolute !important;
    right: 10px;
    margin: 10px;
    padding: 6px;
    font-size: 24px !important;
    z-index: 99;
  }

  .download-image {
    background-color: #fff;
    border-radius: 50%;
    position: absolute !important;
    left: 10px;
    margin: 10px;
    padding: 6px;
    font-size: 24px !important;
    z-index: 99;
  }

  .add {
    text-align: center;
    border: 1px dashed rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    padding: 10px 20px;
  }
}

.voice-recognition {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &.recording {
    color: #fff;
    background-color: #48b38b;
    border-color: #48b38b;
  }
}

.media-grid {
  gap: 10px;

  .media-section-items {
    display: grid;
    gap: 12px;

    &:not(.single-column) {
      grid-template-columns: 1fr 1fr;
    }

    &.single-column {
      grid-template-columns: 1fr;
    }

    .media-item {
      position: relative;
      height: 214px;
      border-radius: 8px;
      overflow: hidden;
      background: transparent;
      width: 100%;
    }
  }
}

.capture-box {
  text-align: center;
  border: 1px dashed rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  height: -webkit-fill-available;
  cursor: pointer;
  background: #fafafa;
  transition: all 0.2s ease;
}

.capture-box--inner {
  height: 214px;
}

.capture-box--add {
  width: 100%;
  height: 60px;
}

.capture-box__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 8px;
}

.add-text {
  font-size: 14px;
  font-weight: 500;
}

.add-media-row {
  margin-bottom: 15px;
}

.media-item {
  position: relative;
  height: 214px;
  border-radius: 8px;
  overflow: hidden;
  background: transparent;
  width: 100%;
}

.media-item.has-image {
  background: #000;
}

.media-item.not-synced {
  border: 4px #fb8c00 solid;
}

.media-thumb {
  width: 100%;
  height: 100%;

  img {
    object-fit: cover;
  }
}

video.media-thumb {
  background: #000;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-thumb--video {
  cursor: pointer;
}

:deep(.viewer-image) {
  cursor: pointer;
}

.video-thumbnail-container {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.media-date {
  position: absolute;
  left: 6px;
  right: 6px;
  bottom: 6px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
}

.media-actions {
  position: absolute;
  left: 6px;
  top: 6px;
  right: 6px;
  display: flex;
  justify-content: flex-end;
  pointer-events: auto;
}

.info-message {
  background-color: rgb(238, 238, 238);
  padding: 10px;
  font-size: 13px;
  text-align: center;
  border-radius: 6px;
  margin-top: 10px;
  color: #666;
}

.chooser-grid {
  padding: 20px;
  background-color: #eee;

  .chooser-grid-title {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #000;
    text-align: center;
    margin-bottom: 16px;
    background-color: #fff;
    padding: 10px;
    border-radius: 8px;
  }

  .chooser-grid-top {
    display: flex;
    flex-direction: row;
    gap: 14px;
    margin-bottom: 16px;

    .chooser-grid-item {
      height: 180px;
    }
  }

  .chooser-grid-bottom {
    .chooser-grid-item {
      height: 110px;
    }
  }

  .chooser-grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 1px dashed rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    cursor: pointer;
    background: #fafafa;
    width: 100%;

    .chooser-grid-item-icon {
      background-color: #eee;
      border-radius: 10%;
      padding: 10px;
    }

    .chooser-grid-item-title {
      margin-top: 12px;
    }
  }
}

.video-player {
  width: 100%;
  height: auto;
  background: #000;
}

.upload-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding: 6px 12px;
  background-color: rgba(25, 118, 210, 0.1);
  border-radius: 16px;
  border: 1px solid rgba(25, 118, 210, 0.3);

  .upload-text {
    font-size: 12px;
    font-weight: 500;
    color: #1976d2;
  }
}
</style>
